module.exports = __webpack_public_path__ + "static/img/five.0b75e51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teams/five.png
// module id = 1U/A
// module chunks = 0